import Vue from "vue";
import Router from "vue-router";
import RouterView from "../layouts/RouterView.vue";

Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", redirect: "/search" },
    {
      path: "/search",
      name: "search",
      component: () => import("@/pages/search/search"),
      meta: { title: "学生量表" }
    },
    {
      path: "/instruction",
      name: "instruction",
      component: () => import("@/pages/instruction/instruction"),
      meta: { title: "学生须知" }
    },
    {
      path: "/scaleTest",
      name: "scaleTest",
      component: () => import("@/pages/scaleTest/scaleTest"),
      meta: { title: "学生测评" }
    },
    {
      path: "/inputOtherInfo",
      name: "inputOtherInfo",
      component: () => import("@/pages/inputOtherInfo/inputOtherInfo"),
      meta: { title: "信息录入" }
    },
    {
      path: "/finish",
      name: "finish",
      component: () => import("@/pages/finish/finish"),
      meta: { title: "测评完成" }
    },

    {
      path: "/firm",
      name: "firm",
      component: RouterView,
      redirect: "/firm/firmOtherInfo",
      children: [
        {
          path: "firmOtherInfo",
          name: "firmOtherInfo",
          component: () => import("@/pages/firm/firmOtherInfo/firmOtherInfo"),
          meta: { title: "信息录入" }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js